import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  Modal,
  TextField,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setIsLoading } from "../../../features/datatable/dataTableSlice";

import {
  getHeaders,
  createAnalysis,
  getStringValues,
} from "../../../utils/computation/analysis";
import { getColumnValues } from "../../../utils/computation/getColumnValues";
import { getallPriceTimeSeries } from "../../../utils/computation/getallPriceTimeSeries";
import Dropdown from "../../Dropdown";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  p: 3,
  borderRadius: "15px",
};

const BoxPlotVariableInput = ({ value, onChange, inputNumber, options }) => {
  return (
    <>
      <Grid item xs={12} sm={12} md={12}>
        <h3> Array {inputNumber + 1} </h3>
        <FormControl variant="filled" fullWidth>
          <InputLabel id="demo-simple-select-label">Select a column</InputLabel>
          <Dropdown
            labelId="histogram-group-select-label"
            id="histogram-group-select"
            value={value}
            onChange={onChange}
            options={options}
          />
        </FormControl>
      </Grid>
    </>
  );
};

const AllPricesTimeSeriesModal = ({
  title,
  closeMenu,
  openModal,
  setOpenModal,
}) => {
  //local states
  const [selectedColumn, setSelectedColumn] = useState("");

  const [newTitle, setnewTitle] = useState("");
  const [yLabel, setyLabel] = useState("");
  const [xLabel, setxLabel] = useState("");

  const [numberOfColumns, setNumberOfColumns] = useState(2);
  const [selectedColumns, setSelectedColumns] = useState(["", ""]);

  //params
  const { documentId } = useParams();

  //dispatch
  const dispatch = useDispatch();

  //redux states
  const { token } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.dataTable);

  //functions

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    closeMenu();
    setOpenModal(false);
  };

  const createGraph = async () => {
    dispatch(setIsLoading());
    // get the array value of selected column
    const value = selectedColumns
      .filter((col) => col !== "")
      .map((col) => getColumnValues(data, col));

    const header = selectedColumns
      .filter((col) => col !== "")
      .map((col) => {
        let head = getHeaders(data, col);
        return head[0];
      });

    const datesArray = getStringValues(data, selectedColumn);

    let graphResult;
    closeMenu();

    if (value.length > 0) {
      graphResult = await getallPriceTimeSeries({
        arr: value,
        dates: datesArray,
        arrTitles: header,
        title: newTitle,
        ylabel: yLabel,
        xlabel: xLabel,
      });

      //populate analysis object
      const graphs = {
        ...graphResult,
        column: selectedColumns.join(", "),
        title,
      };

      try {
        //update user document
        const resFromCreateAnalysis = await createAnalysis(
          token,
          documentId,
          graphs
        );
        graphs.id = resFromCreateAnalysis.id;
      } catch (error) {}

      // dispatch(addAnalysisAndGraphs(graphs)); // add dispatch here
      dispatch(setIsLoading());
    } else {
      dispatch(setIsLoading());
    }
  };
  const inputRef = useRef(null);

  const boxPlotInputs = [];

  for (let i = 0; i < numberOfColumns; i++) {
    boxPlotInputs.push(
      <BoxPlotVariableInput
        key={i}
        value={selectedColumns[i]}
        onChange={(e) => handleColumnSelectChange(e, i)}
        onChangeTitle={(e) => setnewTitle(e.target.value)}
        inputNumber={i}
      />
    );
  }

  const handleColumnSelectChange = (event, i) => {
    setSelectedColumns((oldArray) => {
      return oldArray.map((item, indexInOldArray) => {
        return indexInOldArray === i ? event.target.value : item;
      });
    });
  };

  const addVariableInput = () => {
    setSelectedColumns((v) => [...v, ""]);
    setNumberOfColumns((v) => v + 1);
  };

  return (
    <Modal
      open={openModal === title}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      BackdropProps={{
        onClick: (event) => event.stopPropagation(),
      }}
      disableEnforceFocus
    >
      <Box sx={style}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <>
            <Grid item xs={12} sm={12} md={12}>
              <h1>{title}</h1>
            </Grid>

            <Grid item xs={6} sm={6} md={6} sx={{ mt: 0.8 }}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                {boxPlotInputs}
                <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justify="center"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={3}>
                    <Button
                      variant="contained"
                      style={{
                        width: "auto",
                        borderRadius: "7px",
                      }}
                      onClick={addVariableInput}
                    >
                      Add Variables
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <h3>Dates</h3>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select a column
                </InputLabel>
                <Dropdown
                  labelId="histogram-group-select-label"
                  id="histogram-group-select"
                  // value={dates}
                  onChange={(e) => setSelectedColumn(e.target.value)}
                />
              </FormControl>
              <h3>Title</h3>
              <TextField
                fullWidth
                id="filled-basic"
                variant="filled"
                label="Title"
                sx={{ mt: 1.8 }}
                inputRef={inputRef}
                onChange={(e) => {
                  setnewTitle(e.target.value);
                }}
              />
              <h3>X-Label</h3>
              <TextField
                fullWidth
                id="filled-basic"
                variant="filled"
                label=" X-Label"
                sx={{ mt: 1.8 }}
                onChange={(e) => setxLabel(e.target.value)}
              />
              <h3>Y-Label</h3>
              <TextField
                fullWidth
                id="filled-basic"
                variant="filled"
                label="Y-Label"
                sx={{ mt: 1.8 }}
                onChange={(e) => setyLabel(e.target.value)}
              />
            </Grid>
          </>
        </Grid>

        {/* ACTION BUTTONS */}
        <div
          style={{
            display: "flex",
            float: "right",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          <Button
            variant="outlined"
            style={{
              borderRadius: "7px",
            }}
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              width: "auto",
              marginLeft: "10px",
              borderRadius: "7px",
            }}
            onClick={() => createGraph()}
          >
            Run Function
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default AllPricesTimeSeriesModal;
